module.exports = __webpack_public_path__ + "bg.7b506727a0fd4886b584.png";


//////////////////
// WEBPACK FOOTER
// /Users/Guest/Desktop/meme/src/assets/img/bg.png
// module id = ../../../../../src/assets/img/bg.png
// module chunks = styles